import {GET} from '../constants/API_CONSTANTS';
import {request} from '../utils/request';
import {API_GET_MENU_ITEMS} from '../constants/API_ENDPOINTS';

const getServiceMenuItemsApi = async () => {
  return request(GET, API_GET_MENU_ITEMS());
};

export default getServiceMenuItemsApi;
